<template>
    <div class="slots-wrapper">
        <div id="slots-canvas" :class="[{'z-index-1':!showControls}]">
        </div>
        <div id="slots-panel">
            <div class="">
                <div v-if="canvasReady" :class="[{'mobile':isMobile, 'slots-panel-container':true}]">
                    <Message></Message>
                    <Info :show="infoActive" :starting-context="infoContext" @hidden="infoActive = false"></Info>
                    <b-col class="lifetime-amount" v-if="displayLifetimeAmount && lifetimeAmount !== undefined">{{ 'lifetime_amount' | lang }}: {{ lifetimeAmount | currency }}</b-col>
                    <b-col cols="12" class="top">
                        <b-row>
                            <b-col cols="12" class="d-flex align-items-center all-controls" v-if="showControls">
                                <AmountPicker :controlsDisabled="controlsDisabled"> </AmountPicker>
                                <div class="d-flex spin-controls">
                                    <AutoSpinner v-if="showAutoSpins" :controlsDisabled="controlsDisabled">
                                    </AutoSpinner>
                                    <button @click="purchase" id="purchase" class="ml-3 mr-3">
                                        <span>
                                            <fa-icon icon="sync" v-if="!freeSpinsCurrent"></fa-icon>
                                            <fa-icon icon="spinner" v-else></fa-icon>
                                        </span>
                                        <div v-if="freeSpinsCurrent" class="left">
                                            {{freeSpinsLeft}}
                                        </div>
                                    </button>
                                    <Speed> </Speed>
                                </div>
                                <PaylinePicker :controlsDisabled="controlsDisabled"> </PaylinePicker>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" :class="[{'z-index-100':!showControls, 'bottom':true}]">
                        <b-row>
                            <b-col cols="12" md="3"
                                class="settings order-2 order-md-0 text-center text-md-left align-self-center">
                                <span @click="activateInfo('settings')">
                                    <fa-icon icon="cogs"></fa-icon>
                                </span>
                                <span @click="activateInfo('tutorial')">
                                    <fa-icon icon="info"></fa-icon>
                                </span>
                                <span @click="toggleMute">
                                    <fa-icon icon="volume-up" v-if="!mute"></fa-icon>
                                    <fa-icon icon="volume-off" v-else></fa-icon>
                                </span>
                            </b-col>
                            <b-col cols="12" md="6"
                                class="d-flex justify-content-center order-0 order-md-0 align-self-center" v-if="showControls">
                                <span v-if="amountWon">{{ 'amount_won' | lang }}: {{amountWon | currency}}</span>
                                <span v-else-if="freeSpins">{{ 'free_spins' | lang }}: {{freeSpinsLeft}}</span>
                                <span v-if="totalAmountWon && (amountWon || freeSpins)">&nbsp;|&nbsp;</span>
                                <span v-if="totalAmountWon">{{ 'total_amount_won' | lang }}: {{totalAmountWon | currency}}</span>
                            </b-col>
                            <b-col cols="12" md="3"
                                class="text-center text-md-right order-1 order-md-0 align-self-center" v-if="showControls">
                                <div class="d-inline-block d-md-none">
                                    <span>{{ 'amount' | lang }}: {{ totalAmount | currency }}</span>
                                    <span class="d-sm-none">&nbsp;|&nbsp;</span>
                                    <span>{{ 'paylines_count' | lang }}: {{ currentPayline }}</span>
                                    <span class="d-sm-none" v-if="!demoBalance">&nbsp;|&nbsp;</span>
                                </div>
                                <span v-if="mode === 'real'" class="balance">{{ 'balance' | lang }}: {{balance | currency}}</span>
                                <span v-else-if="demoBalance" class="demo-balance">{{ 'demo_balance' | lang }}: {{balance | currency}}</span>
                                <span v-else>{{ 'demo' | lang }}</span>
                            </b-col>
                        </b-row>
                    </b-col>
                </div>
                <div id = "explanation-transition">
                    <transition id="explanation" name="fade">
                        <Explanation v-if="explanationVisible"> </Explanation>
                    </transition>
                </div>
            </div>
        </div>
        <div class="cool-down-timer" v-if="displayCooldown && cooldownRemaining">{{ cooldownRemaining }}</div>
      <PopClientComponent v-if="popParameters" :parameters="popParameters"></PopClientComponent>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapMutations } from 'vuex';
import AmountPicker from '@sl/base/components/partials/AmountPicker';
import Speed from '@sl/base/components/partials/Speed';
import PaylinePicker from '@sl/base/components/partials/PaylinePicker';
import AutoSpinner from '@sl/base/components/partials/AutoSpinner';
import Info from '@sl/base/components/partials/Info/Container';
import Message from '@sl/base/components/partials/Message';
import Explanation from '@sl/base/components/partials/Info/Explanation';
import PopClientComponent from "./partials/PopClientComponent";

export default {
    components: { AmountPicker, PaylinePicker, AutoSpinner, Info, Message, Speed, Explanation, PopClientComponent },
    data() {
        return {
            infoActive: false,
            infoContext: undefined,
            popParameters: Config.popParameters,
            displayLifetimeAmount: Config.display_lifetime_amount,
            displayCooldown: Config.display_cooldown,
        };
    },
    computed: {
        ...mapState([
            'relayMethods',
            'freeSpins',
            'ticketInProgress',
            'canvasReady',
            'balance',
            'amountWon',
            'totalAmountWon',
            'reelSpinning',
            'autoSpins',
            'device',
            'mute',
            'isLogged',
            'mode',
            'currentAmount',
            'currentPayline',
            'showControls',
            'explanationVisible',
            'popGracefulPause',
            'lifetimeAmount',
            'cooldownGamingEnd',
            'datetime',
        ]),
        controlsDisabled() {
            return !this.canvasReady || !!this.autoSpins || this.reelSpinning || this.freeSpins || this.popGracefulPause;
        },
        isMobile() {
            return this.device === 'mobile';
        },
        freeSpinsLeft() {
            if(!this.freeSpins) {
                return;
            }

            return (this.freeSpins.total - this.freeSpins.current) + 1;
        },
        freeSpinsCurrent() {
            if(!this.freeSpins) {
                return;
            }

            return this.freeSpins.current;
        },
        showAutoSpins() {
            return !Config.settings.hide_auto_spins;
        },
        totalAmount() {
            return this.currentAmount.amount * this.currentPayline;
        },
        demoBalance() {
            return Config.demo_balance;
        },
        cooldownRemaining() {
          if (!this.cooldownGamingEnd) {
            return;
          }

          const from = moment.utc(this.datetime);
          const to = moment.utc(this.cooldownGamingEnd);

          const diff = to.diff(from, 'seconds');

          if (diff <= 0) {
            return;
          }

          const hours = Math.floor(diff / 60 / 60);
          const minutes = Math.floor(diff / 60 - (hours * 60));
          const seconds = diff - minutes * 60 - hours * 60 * 60;

          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },
    },
    methods: {
        ...mapMutations(['toggleMute', 'setMessage', 'setAfterMessage', 'sendPurchase']),
        purchase() {
            if(!this.canvasReady) {
                return;
            }

            if (!this.reelSpinning && this.popGracefulPause) {
              return;
            }

            this.sendPurchase();
        },

        activateInfo(context) {
          if (!this.reelSpinning && this.popGracefulPause) {
            return;
          }

          this.infoActive = true;
            this.infoContext = context;
            
            this.relayMethods.clickEvent('activateInfo');
        },
    },
    created: function () {
      if (Config.player_text) {
        this.setMessage(Config.player_text);
        if (Config.player_action === 'reload') {
          this.setAfterMessage(() => location.reload());
        }
      } else {
        if(this.mode === 'real' && !this.isLogged && !Config.replay_id) {
          this.setMessage('please_login');
        }
      }
    }
}
</script>

<style>
    #explanation-transition .fade-leave-active {
        transition: opacity .6s;
    }
    #explanation-transition .fade-enter, #explanation-transition .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>